import { InjectionToken, ModuleWithProviders, NgModule } from '@angular/core';
import { Action, ActionReducer, StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StandbyEntryCompletionResultEffect } from './standby-entry-completion-result.effect';
import { standbyEntryCompletionResultReducer } from './standby-entry-completion-result.reducer';
import {
  STANDBY_ENTRY_COMPLETION_RESULT_STORE_NAME,
  StandbyEntryCompletionResultState,
} from './standby-entry-completion-result.state';

/** Token of the StandbyEntryCompletionResult reducer */
export const STANDBY_ENTRY_COMPLETION_RESULT_REDUCER_TOKEN = new InjectionToken<
  ActionReducer<StandbyEntryCompletionResultState, Action>
>('Feature StandbyEntryCompletionResult Reducer');

/** Provide default reducer for StandbyEntryCompletionResult store */
export function getDefaultStandbyEntryCompletionResultReducer() {
  return standbyEntryCompletionResultReducer;
}

@NgModule({
  imports: [
    StoreModule.forFeature(STANDBY_ENTRY_COMPLETION_RESULT_STORE_NAME, STANDBY_ENTRY_COMPLETION_RESULT_REDUCER_TOKEN),
    EffectsModule.forFeature([StandbyEntryCompletionResultEffect]),
  ],
  providers: [
    {
      provide: STANDBY_ENTRY_COMPLETION_RESULT_REDUCER_TOKEN,
      useFactory: getDefaultStandbyEntryCompletionResultReducer,
    },
  ],
})
export class StandbyEntryCompletionResultStoreModule {
  public static forRoot<T extends StandbyEntryCompletionResultState>(
    reducerFactory: () => ActionReducer<T, Action>
  ): ModuleWithProviders<StandbyEntryCompletionResultStoreModule> {
    return {
      ngModule: StandbyEntryCompletionResultStoreModule,
      providers: [{ provide: STANDBY_ENTRY_COMPLETION_RESULT_REDUCER_TOKEN, useFactory: reducerFactory }],
    };
  }
}
